// extracted by mini-css-extract-plugin
export var sliderRange = "_cu-2";
export var sliderRoot = "_cu-0";
export var sliderThumb = "_cu-3";
export var sliderTrack = "_cu-1";